"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useRefChangeWatcher = (ref, cb) => {
    const previous = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (previous.current !== ref.current) {
            previous.current = ref.current;
            cb(ref.current);
        }
    });
};
exports.default = useRefChangeWatcher;
